import { Box, Typography, Button } from "@mui/material";
import { Link } from "react-router";

const Unauthorized = () => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "70vh",
                textAlign: "center",
                gap: 2,
            }}
        >
            <Typography variant="h2" color="primary" sx={{ fontWeight: 800 }}>
                403
            </Typography>
            <Typography variant="h5" sx={{ maxWidth: 520 }}>
                You don’t have permission to access this page.
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 520 }}>
                If you believe this is a mistake, please contact your administrator to request access.
            </Typography>
            <Button component={Link} to="/" variant="contained" sx={{ mt: 1 }}>
                Go to Dashboard
            </Button>
        </Box>
    );
};

export default Unauthorized;


